import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
// Connects to data-controller="bridge--authentication"
export default class extends BridgeComponent {
  static component = "authentication"
  static values = {
    authenticated: Boolean
  }

 connect() {
    super.connect()

    const raw = this.element.getAttribute("data-bridge--authentication-bridge-authenticated-value")
    const authenticated = raw === "true"
    console.log("authenticated value:", authenticated)

    this.send("connect", { authenticated })
  }
}
